// extracted by mini-css-extract-plugin
export var globalFooter = "__App-module___globalFooter";
export var globalHeader = "__App-module___globalHeader";
export var siteContainer = "__App-module___siteContainer";